import React, { useState, useEffect } from "react"
import { Link, useHistory } from "react-router-dom"
import logo from "./../../../assets/images/logo.png"
import smChatIcon from "./../../../assets/icons/sm_chat.svg"
import smcommunityIcon from "./../../../assets/icons/sm_community.svg"
import supports_Icon from "./../../../assets/icons/supports.svg"
import smLogoutIcon from "./../../../assets/icons/sm_logout.svg"
import userImg from "./../../../assets/images/user.png"
import shoppingBagIcon from "./../../../assets/icons/shopping-bag.svg"
import creditCardIcon from "./../../../assets/icons/credit-card.svg"
import couponIcon from "./../../../assets/icons/coupon.svg"
import notificationBellIcon from "./../../../assets/icons/notification-bell.svg"
import chatIcon from "./../../../assets/icons/chat.svg"
import logoutIcon from "./../../../assets/icons/logout.svg"
import productIcon from "./../../../assets/icons/products_icon.svg"
import serviceIcon from "./../../../assets/icons/services_icon.svg"
import discountIcon from "./../../../assets/icons/discounts_icon.svg"
import customersIcon from "./../../../assets/icons/customers_icon.svg"
import vendorIcon from "./../../../assets/icons/vendors_icon.svg"
import reportIcon from "./../../../assets/icons/reports_icon.svg"
import communityIcon from "./../../../assets/icons/community_icon.svg"
import bannerIcon from "./../../../assets/icons/banners_icon.svg"
import supportIcon from "./../../../assets/icons/support_icon.svg"
import clostBtn from "./../../../assets/icons/close_icon.svg"
import blackBellIcon from "../../../assets/icons/notification-black-bell-icon.svg"
import homeIcon from "./../../../assets/icons/sm_home.svg"
import { bindHeaderOffcanvasLifecycle, dismissOffcanvasThen } from "../../../helpers/offcanvas-cleanup"
import { useSelector, useDispatch } from "react-redux"
import { setLoginStatus, setUserInfo } from "./../../../store/reducers/auth-reducer"
import io from "socket.io-client"
import axios from "axios"
import { NavLink } from "react-router-dom";
import SideMenuLink from "../../common/SideMenuLink";
import "../../../assets/css/admin-legal-submenu.css";

const dismissOpenOffcanvasThen = (callback) => {
  const sideMenu = document.getElementById("sideMenu")
  const offcanvasNavbar = document.getElementById("offcanvasNavbar")

  if (offcanvasNavbar?.classList.contains("show")) {
    dismissOffcanvasThen("offcanvasNavbar", () => {
      if (sideMenu?.classList.contains("show")) {
        dismissOffcanvasThen("sideMenu", callback)
      } else {
        callback?.()
      }
    })
    return
  }

  dismissOffcanvasThen("sideMenu", callback)
}

function Header() {
  const userInfo = useSelector((state) => state.auth.userInfo)
  const authInfo = useSelector((state) => state.auth.authInfo)
  const dispatch = useDispatch()
  const history = useHistory()
  const [unreadCount, setUnreadCount] = useState(0)
  const [permissions, setPermissions] = useState(null)
  const [legalSubmenuOpen, setLegalSubmenuOpen] = useState(false)

  // Helper function. 
  const hasAnyPermission = (module) => {
    // Super admin can see everything
    if (userInfo.role === "super_admin") return true
    
    if (!permissions || !permissions[module]) return false
    const { add, edit, delete: deletePermission } = permissions[module]
    return add || edit || deletePermission
  }

  // Function to fetch user permissions
  const getUserPermissions = async () => {
    try {
      const response = await axios.get(`admin/getAllpermission/${authInfo.id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${authInfo.token}`,
        },
      })

      if (response.data.status === true) {
        setPermissions(response.data.data)
      }
    } catch (error) {
      console.error("Error fetching permissions:", error)
    }
  }

  const getAdminProfile = async () => {
    try {
      const response = await axios.get(`admin/my-profile/${authInfo.id}`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: `Bearer ${authInfo.token}`,
        },
      })

      if (response.data.status === true) {
        const adminInfo = response.data.data
        if (adminInfo.image_url && adminInfo.image_url !== "") {
          const userInfo = {
            name: adminInfo.name,
            email: adminInfo.email,
            role: adminInfo.role,
            imgUrl: adminInfo.image_url,
          }
          dispatch(setUserInfo({ userInfo }))
          localStorage.setItem("userInfo", JSON.stringify(userInfo))
        }
      }
    } catch (error) {
      console.error()
    }
  }

  useEffect(() => {
    getAdminProfile()
    getUserPermissions() // Fetch permissions on component mount
    
    const socket = io.connect(process.env.REACT_APP_SOCKET_SERVER_URL)

    const fetchNotifications = async () => {
      if (authInfo && authInfo.id) {
        socket.emit("allNotifications", { userID: authInfo.id })

        axios.get(`front/notifications/${authInfo.id}`).then((response) => {
          const responseData = response.data.data
          if (responseData > 0) {
            const offlineNotifications = responseData.filter((notification) => !notification.notification.isRead)
            if (offlineNotifications && offlineNotifications.length > 0) {
              offlineNotifications.forEach((notification) => {
                setUnreadCount((prevCount) => prevCount + 1)
              })
            }
          }
        })
      }
    }

    fetchNotifications()

    socket.on("receive_notification", (notification) => {
      if (!notification || !notification.message) {
        console.error("Received invalid notification data:", notification)
        return
      }
      setUnreadCount((prevCount) => prevCount + 1)
    })

    return () => {
      socket.off("receive_notification")
      socket.disconnect()
    }
  }, [authInfo])

  useEffect(() => bindHeaderOffcanvasLifecycle((path) => history.push(path)), [history])

  const executeLogout = () => {
    dispatch(setLoginStatus({ isLoggedIn: false }))
    localStorage.clear()
    dispatch(setUserInfo({ userInfo: [] }))
    window.location.href = "/admin/login"
  }

  const logout = async () => {
    const { unregisterFcmBeforeLogout } = await import("../../../helpers/fcm-logout")
    await unregisterFcmBeforeLogout()
    dismissOpenOffcanvasThen(executeLogout)
  }

  const handleLogoutClick = (event) => {
    event.preventDefault()
    logout()
  }

  const handleNotificationClick = () => {
    axios.put(`front/updateNotifications/${authInfo.id}`).then((response) => {
      const offlineNotifications = response.data.data
      console.log("offlineNotifications", offlineNotifications)
    })
    setUnreadCount(0)
  }

  return (
    <React.Fragment>
      <div
        className="offcanvas offcanvas-start side_menu_wrap"
        tabIndex="-1"
        id="sideMenu"
        aria-labelledby="sideMenuLabel"
      >
        <div className="offcanvas-header">
          <button type="button" className="view_more text-reset" data-bs-dismiss="offcanvas" aria-label="Close">
            <img src={clostBtn || "/placeholder.svg"} className="img-fluid" alt="" loading="lazy" decoding="async" />{" "}
            Close
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="side_menu_body">
            <ul className="side_menu_links">
              {/* Dashboard - Always show if user has dashboard permissions */}
              {hasAnyPermission('dashboard') && (
                <li>
                  <SideMenuLink to="/admin/dashboard">
                    <i className="icon">
                      <img src={homeIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                    </i>{" "}
                    Dashboard
                  </SideMenuLink>
                </li>
              )}

              {/* Legal Documents Section - Only for law_body role */}
              {(userInfo.role === "law_body" || userInfo.role === "super_admin") && (
                <li className="admin-legal-submenu">
                  <button
                    type="button"
                    className="admin-legal-submenu__trigger"
                    onClick={() => setLegalSubmenuOpen((open) => !open)}
                    aria-expanded={legalSubmenuOpen}
                    aria-controls="adminLegalSubmenu"
                  >
                    <i className="icon">
                      <img src={reportIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                    </i>
                    <span className="admin-legal-submenu__label">Legal Management</span>
                    <span
                      className={`admin-legal-submenu__chevron ${legalSubmenuOpen ? "is-open" : ""}`}
                      aria-hidden="true"
                    />
                  </button>
                  <div
                    id="adminLegalSubmenu"
                    className={`admin-legal-submenu__panel ${legalSubmenuOpen ? "is-open" : ""}`}
                  >
                    <ul className="admin-legal-submenu__list">
                      <li>
                        <NavLink
                          to="/admin/legal-documents"
                          className="admin-legal-submenu__item"
                          activeClassName="is-active"
                        >
                          Legal Documents
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/legal-documents/create"
                          className="admin-legal-submenu__item"
                          activeClassName="is-active"
                        >
                          Create Document
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to="/admin/legal-agreements"
                          className="admin-legal-submenu__item"
                          activeClassName="is-active"
                        >
                          User Agreements
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </li>
              )}

              {/* Regular admin menu items - hidden for law_body role */}
              {userInfo.role !== "law_body" && (
                <>
                  {/* CMS Management */}
                  {hasAnyPermission('manage_cms') && (
                    <li>
                      <SideMenuLink to="/admin/cms">
                        <i className="icon">
                          <img src={bannerIcon} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage CMS
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Manage Seller License */}
                  {hasAnyPermission('manage_seller_license') && (
                    <li>
                      <SideMenuLink to="/admin/seller-licenses">
                        <i className="icon">
                          <img src={vendorIcon} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Seller Licenses
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Posts Management */}
                  {hasAnyPermission('post') && (
                    <li>
                      <SideMenuLink to="/admin/manage-posts">
                        <i className="icon">
                          <img src={communityIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Posts
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Product Orders */}
                  {hasAnyPermission('manage_orders') && (
                    <li>
                      <SideMenuLink to="/admin/product-orders">
                        <i className="icon">
                          <img src={shoppingBagIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Product Orders
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Service Orders */}
                  {hasAnyPermission('manage_services_orders') && (
                    <li>
                      <SideMenuLink to="/admin/service-orders">
                        <i className="icon">
                          <img src={serviceIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Service Orders
                      </SideMenuLink>
                    </li>
                  )}

                  {hasAnyPermission('manage_flat_fee') && (
                    <li>
                      <SideMenuLink to="/admin/manage-flat-fee">
                        <i className="icon">
                          <img src={discountIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Flat Fee
                      </SideMenuLink>
                    </li>
                  )}

                  {hasAnyPermission('manage_flat_fee') && (
                    <li>
                      <SideMenuLink to="/admin/stripe-payout">
                        <i className="icon">
                          <img src={creditCardIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Stripe payouts
                      </SideMenuLink>
                    </li>
                  )}

                  {hasAnyPermission('manage_flat_fee') && (
                    <li>
                      <SideMenuLink to="/admin/seller-earnings">
                        <i className="icon">
                          <img src={reportIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Seller Earnings
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Categories Dropdown */}
                  {(hasAnyPermission('products_categories') || 
                    hasAnyPermission('services_categories') || 
                    hasAnyPermission('blogs_categories')) && (
                    <li className="nav-item dropdown">
                      <a
                        href="#"
                        className="nav-link dropdown-toggle"
                        id="categoryDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        onClick={(e) => e.preventDefault()}
                      >
                        <i className="icon">
                          <img src={productIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Categories
                      </a>
                      <ul className="dropdown-menu" aria-labelledby="categoryDropdown">
                        {hasAnyPermission('products_categories') && (
                          <li>
                            <SideMenuLink to="/admin/manage-product-categories" className="dropdown-item" >
                              Products Category
                            </SideMenuLink>
                          </li>
                        )}
                        {hasAnyPermission('services_categories') && (
                          <li>
                            <SideMenuLink to="/admin/manage-service-categories" className="dropdown-item">
                              Service Category
                            </SideMenuLink>
                          </li>
                        )}
                        {hasAnyPermission('blogs_categories') && (
                          <li>
                            <SideMenuLink to="/admin/manage-blog-Categories" className="dropdown-item">
                              Blog Category
                            </SideMenuLink>
                          </li>
                        )}
                      </ul>
                    </li>
                  )}

                  {/* Currencies Management */}
                  {hasAnyPermission('manage_currencies') && (
                    <li>
                      <SideMenuLink to="/admin/manage-currencies">
                        <i className="icon">
                          <img src={creditCardIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Currencies
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Products Management */}
                  <li>
                    <SideMenuLink to="/admin/manage-products">
                      <i className="icon">
                        <img src={productIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                      </i>{" "}
                      Manage Products
                    </SideMenuLink>
                  </li>

                  {/* Services Management */}
                  {hasAnyPermission('manage_service') && (
                    <li>
                      <SideMenuLink to="/admin/manage-services">
                        <i className="icon">
                          <img src={serviceIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>
                        Manage Services
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Deals Management */}
                  {hasAnyPermission('manage_deals') && (
                    <li>
                      <SideMenuLink to="/admin/manage-deals">
                        <i className="icon">
                          <img src={discountIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Deals
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Coupons Management */}
                  {hasAnyPermission('manage_coupons') && (
                    <li>
                      <SideMenuLink to="/admin/manage-coupons">
                        <i className="icon">
                          <img src={couponIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Coupons
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Brands Management */}
                  {hasAnyPermission('manage_brand') && (
                    <li>
                      <SideMenuLink to="/admin/manage-brands">
                        <i className="icon">
                          <img src={vendorIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Brands
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Customers Management */}
                  {hasAnyPermission('manage_customers') && (
                    <li>
                      <SideMenuLink to="/admin/manage-customers">
                        <i className="icon">
                          <img src={customersIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Customers
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Vendors Management */}
                  {hasAnyPermission('manage_vendors') && (
                    <li>
                      <SideMenuLink to="/admin/manage-vendors">
                        <i className="icon">
                          <img src={vendorIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Vendors
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Manage Admins - Only for super_admin */}
                  {userInfo.role === "super_admin" && (
                    <li>
                      <SideMenuLink to="/admin/manage-admins">
                        <i className="icon">
                          <img src={customersIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Admins
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Reports */}
                  {hasAnyPermission('manage_reports') && (
                    <li>
                      <SideMenuLink to="/admin/product-reports">
                        <i className="icon">
                          <img src={reportIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Reports
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Community */}
                  <li>
                    <SideMenuLink to="/admin/community">
                      <i className="icon">
                        <img src={communityIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                      </i>{" "}
                      Community
                    </SideMenuLink>
                  </li>

                  {/* Advertisements Management */}
                  {hasAnyPermission('manage_advertisement') && (
                    <li>
                      <SideMenuLink to="/admin/manage-advertisement">
                        <i className="icon">
                          <img src={bannerIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Advertisements
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Subscription Management */}
                  {hasAnyPermission('manage_subcription') && (
                    <li>
                      <SideMenuLink to="/admin/manage-subscription">
                        <i className="icon">
                          <img src={creditCardIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Manage Subscription
                      </SideMenuLink>
                    </li>
                  )}

                  {/* Contact Buyers */}
                  {hasAnyPermission('manage_contact_buyers') && (
                    <li>
                      <SideMenuLink to="/admin/buyers-contact">
                        <i className="icon">
                          <img src={customersIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                        </i>{" "}
                        Contact Buyers
                      </SideMenuLink>
                    </li>
                  )}
                </>
              )}

              {/* Disputes Management - Common for all roles */}
              {hasAnyPermission('manage_disputes') && (
                <li>
                  <SideMenuLink to="/admin/disputes">
                    <i className="icon">
                      <img src={chatIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                    </i>{" "}
                    Manage Disputes
                  </SideMenuLink>
                </li>
              )}

              {/* Common menu items for all roles */}
              <li>
                <SideMenuLink to="/admin/chat">
                  <i className="icon">
                    <img src={chatIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                  </i>{" "}
                  Chats
                </SideMenuLink>
              </li>

              <li>
                <SideMenuLink to="/admin/manage-support">
                  <i className="icon">
                    <img src={supportIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                  </i>
                  Manage Support
                </SideMenuLink>
              </li>

              <li>
                <SideMenuLink to="/admin/notifications">
                  <i className="icon">
                    <img src={notificationBellIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                  </i>{" "}
                  Notifications
                </SideMenuLink>
              </li>

              <li>
                <a href="#" role="button" onClick={handleLogoutClick}>
                  <i className="icon">
                    <img src={logoutIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                  </i>
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Header content remains the same */}
      <header className="header">
        <div className="main_nav seller_dash_nav">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <nav className="navbar navbar-expand-lg py-0">
                  <div className="container-fluid p-0">
                    <div className="side_menu_btn">
                      <button
                        className="btn"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#sideMenu"
                        aria-controls="sideMenu"
                      >
                        <span className="menu_btn_icon"></span>
                      </button>
                    </div>
                    <Link className="navbar-brand py-0" to="/admin/dashboard">
                      <img
                        src={logo || "/placeholder.svg"}
                        alt="logo"
                        className="img-fluid h-100"
                        loading="lazy"
                        decoding="async"
                      />
                    </Link>
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasNavbar"
                      aria-controls="offcanvasNavbar"
                    >
                      <span className="fa fa-bars"></span>
                    </button>
                    <div
                      className="offcanvas offcanvas-end"
                      tabIndex="-1"
                      id="offcanvasNavbar"
                      aria-labelledby="offcanvasNavbarLabel"
                    >
                      <div className="offcanvas-header">
                        <button
                          type="button"
                          className="btn-close text-reset ms-auto"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="offcanvas-body d-block">
                        <ul className="seller_menu navbar-nav justify-content-end flex-grow-1 pe-0">
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active-menu" : ""}`
                              }
                              to="/admin/notifications"
                              onClick={handleNotificationClick}
                            >
                              <div className="sm_icon">
                                <img
                                  src={blackBellIcon || "/placeholder.svg"}
                                  alt=""
                                  loading="lazy"
                                  decoding="async"
                                />
                                {unreadCount > 0 && (
                                  <span className="notification-count">{unreadCount}</span>
                                )}
                              </div>
                              <span>Notifications</span>
                            </NavLink>
                          </li>

                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active-menu" : ""}`
                              }
                              to="/admin/chat"
                            >
                              <div className="sm_icon">
                                <img
                                  src={smChatIcon || "/placeholder.svg"}
                                  alt=""
                                  loading="lazy"
                                  decoding="async"
                                />
                              </div>
                              <span>Chat</span>
                            </NavLink>
                          </li>

                          {userInfo.role !== "law_body" && (
                            <li className="nav-item">
                              <NavLink
                                className={({ isActive }) =>
                                  `nav-link ${isActive ? "active-menu" : ""}`
                                }
                                to="/admin/community"
                              >
                                <div className="sm_icon">
                                  <img
                                    src={smcommunityIcon || "/placeholder.svg"}
                                    alt=""
                                    loading="lazy"
                                    decoding="async"
                                  />
                                </div>
                                <span>Community</span>
                              </NavLink>
                            </li>
                          )}

                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active-menu" : ""}`
                              }
                              to="/admin/manage-support"
                            >
                              <div className="sm_icon">
                                <img
                                  src={supports_Icon || "/placeholder.svg"}
                                  alt=""
                                  loading="lazy"
                                  decoding="async"
                                />
                              </div>
                              <span>Support</span>
                            </NavLink>
                          </li>
                          <li className="nav-item">
                            <a href="#" role="button" className="nav-link" onClick={handleLogoutClick}>
                              <div className="sm_icon">
                                <img src={smLogoutIcon || "/placeholder.svg"} alt="" loading="lazy" decoding="async" />
                              </div>
                              <span>Logout</span>
                            </a>
                          </li>
                          <li className="nav-item dropdown">
                            <a
                              className="nav-link dropdown-toggle"
                              href="#"
                              id="navbarDropdown"
                              role="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={(e) => e.preventDefault()}
                            >
                              <div className="com_user_acc">
                                <div className="com_user_img">
                                  <img
                                    src={userInfo.imgUrl && userInfo.imgUrl.trim() !== "" ? userInfo.imgUrl : userImg}
                                    alt=""
                                    loading="lazy"
                                    decoding="async"
                                  />
                                </div>
                                <div className="com_user_name">
                                  <div className="cu_name">{userInfo.name}</div>
                                  <div>{userInfo.role}</div>
                                </div>
                              </div>
                            </a>
                            <ul className="dropdown-menu dropdown-menu-end mt-5" aria-labelledby="navbarDropdown">
                              <li>
                                <Link className="dropdown-item" to="/admin/my-profile">
                                  My Profile
                                </Link>
                              </li>
                              <li>
                                <hr className="dropdown-divider" />
                              </li>
                              <li>
                                <Link className="dropdown-item" to="/admin/account">
                                  Account
                                </Link>
                              </li>
                              <li>
                                <hr className="dropdown-divider" />
                              </li>
                              <li>
                                <a href="#" role="button" className="dropdown-item" onClick={handleLogoutClick}>
                                  Log Out
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

export default Header